import Lottie from "lottie-react";
import animationData from "../../../../assets/animations/tbSuccessfulPaymentAnimation.json";
import QuoteFormWrapper from "../../../../shared/components/quoteFormWrapper";
import Button from "../../../../shared/components/Button";
import QuoteStepHeading from "../../../../shared/components/QuoteStepHeading";
import PageContentStack from "../../../../shared/components/PageContentStack";

const ReportClaimSuccess = ({ onBack }) => (
  <PageContentStack>
    <QuoteFormWrapper>
      <div className="tw-flex tw-flex-col tw-gap-4">
        <Lottie
          className="-tw-ml-3 tw-h-[65px] tw-w-[65px]"
          animationData={animationData}
          loop={false}
          autoplay
          rendererSettings={{ preserveAspectRatio: "xMidYMid slice" }}
        />
        <QuoteStepHeading title="Success" className="tw-mb-0" />
        <div className="tw-mb-3 tw-flex tw-flex-col tw-gap-3 tw-border-x-0 tw-border-t-0 tw-border-b tw-border-solid tw-border-dis-divider tw-pb-5">
          <p className="tw-m-0 tw-text-base tw-leading-[1.5] tw-text-dis-text-2">
            Your claim has been submitted successfully!
          </p>
        </div>
        <Button fullWidth onClick={onBack}>
          Back to Portal
        </Button>
      </div>
    </QuoteFormWrapper>
  </PageContentStack>
);

export default ReportClaimSuccess;
